import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import theme from './theme';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { AppProvider } from './AppProvider';
import ResponseHandler from './wrapper/AxiosWrapper';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthenticationProvider } from './views/dss/AuthenticationProvider';
import { ConfirmProvider } from 'material-ui-confirm';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ThemeProvider theme={theme}>
      <ConfirmProvider>
        <GoogleOAuthProvider clientId='729656236367-cuk5bu7278p17n3m4mnb8jiq6qd4g8pg.apps.googleusercontent.com'>
          <AuthenticationProvider>
            <AppProvider>
              <ResponseHandler>
                <App />
              </ResponseHandler>
            </AppProvider>
          </AuthenticationProvider>
        </GoogleOAuthProvider>
      </ConfirmProvider>
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
